
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/burnout/doctors",
      function () {
        return require("private-next-pages/services/burnout/doctors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/burnout/doctors"])
      });
    }
  